/* =========================================================
   NoSkinKolor — bilingual engine (EN base ⇄ FR)
   - Static DOM: text nodes + key attributes translated in place
   - Dynamic JS strings (cart/search/toasts): via window.t()
   - Choice persisted in localStorage("nsk-lang")
   ========================================================= */
(function () {
  "use strict";

  const PAIRS = [
    ["Home", "Accueil"],
    ["Shop", "Boutique"],
    ["Archive", "Archive"],
    ["About", "À propos"],
    ["Support", "Support"],
    ["Search", "Rechercher"],
    ["Bag", "Panier"],
    ["Close", "Fermer"],
    ["Menu", "Menu"],
    ["NoSkinKolor — home", "NoSkinKolor — accueil"],
    ["Free shipping on orders over €120", "Livraison offerte dès 120 €"],
    ["Worldwide delivery", "Livraison mondiale"],
    ["S04 — NoSkinKolor — out now", "S04 — NoSkinKolor — disponible"],
    ["Handmade pieces", "Pièces faites main"],
    ["Enter the shop", "Entrer dans la boutique"],
    ["PARIS — 15 JUNE 2025", "PARIS — 15 JUIN 2025"],
    ["Stay updated — subscribe to the newsletter", "Restez informé — inscrivez-vous à la newsletter"],
    ["Drops, editorial & custom leather updates. No noise.", "Drops, éditorial & cuir sur-mesure. Aucun bruit."],
    ["Name", "Nom"],
    ["Email", "E-mail"],
    ["Subscribe", "S'inscrire"],
    ["You're on the list. Welcome.", "Vous êtes inscrit. Bienvenue."],
    ["Your Bag", "Votre panier"],
    ["Your bag is empty", "Votre panier est vide"],
    ["Pieces you love live here.", "Les pièces que vous aimez vivent ici."],
    ["Start with the new drop.", "Commencez par le nouveau drop."],
    ["Shop New Arrivals →", "Voir les nouveautés →"],
    ["Add {x} for free shipping", "Plus que {x} pour la livraison offerte"],
    ["Free shipping unlocked ❖", "Livraison offerte débloquée ❖"],
    ["Size", "Taille"],
    ["Remove", "Retirer"],
    ["Subtotal", "Sous-total"],
    ["Shipping", "Livraison"],
    ["Calculated at checkout", "Calculée au paiement"],
    ["Checkout", "Paiement"],
    ["Continue Shopping", "Continuer mes achats"],
    ["Added to bag", "Ajouté au panier"],
    ["Search products…", "Rechercher un produit…"],
    ["Start typing to search.", "Commencez à taper pour rechercher."],
    ["No results for {q}.", "Aucun résultat pour {q}."],
    ["Taxes included.", "Taxes incluses."],
    ["Color", "Couleur"],
    ["Forest Green", "Vert Forêt"],
    ["Quantity", "Quantité"],
    ["Previous", "Précédent"],
    ["Next", "Suivant"],
    ["Decrease", "Diminuer"],
    ["Increase", "Augmenter"],
    ["Add to bag", "Ajouter au panier"],
    ["✓ Added", "✓ Ajouté"],
    ["More payment options", "Plus d'options de paiement"],
    ["Details & fit", "Détails & coupe"],
    ["Care", "Entretien"],
    ["The story behind the Leopard Zaïre Tee", "L'histoire derrière le T-shirt Leopard Zaïre"],
    ["Join the newsletter", "Rejoignez la newsletter"],
    ["Early access & exclusive drops", "Accès anticipé & drops exclusifs"],
    ["Subscribed — welcome.", "Inscrit — bienvenue."],
    ["Refund Policy", "Politique de remboursement"],
    ["Terms & Conditions", "Conditions générales"],
    ["Shipping Policy", "Politique de livraison"],
    ["Contact", "Contact"],
    ["Legal Notice", "Mentions légales"],
    ["SS26 — No Skin Color — out now", "SS26 — No Skin Color — disponible"],
    ["Custom Leather: made to order in Brussels", "Cuir sur-mesure : fabriqué à la commande à Bruxelles"],
    ["Support.", "Support."],
    ["Customer care", "Service client"],
    ["Mon — Fri · 09:00–18:00 CET", "Lun — Ven · 09h00–18h00 CET"],
    ["Shipping & delivery", "Expédition & livraison"],
    ["Returns & exchanges", "Retours & échanges"],
    ["Contact us", "Nous contacter"],
    ["FAQ", "FAQ"],
    ["How to place an order", "Comment passer commande"],
    ["Size guide", "Guide des tailles"],
    ["Custom Leather products", "Produits Cuir sur-mesure"],
    ["Write to us — we reply within one working day.", "Écrivez-nous — nous répondons sous un jour ouvré."],
    ["Subject", "Objet"],
    ["Message", "Message"],
    ["Order & delivery", "Commande & livraison"],
    ["Custom Leather inquiry", "Demande Cuir sur-mesure"],
    ["Press & collaborations", "Presse & collaborations"],
    ["Other", "Autre"],
    ["Tell us what we can help with…", "Dites-nous comment nous pouvons aider…"],
    ["Send →", "Envoyer →"],
    ["Message sent — we'll be in touch", "Message envoyé — nous reviendrons vers vous"],
    ["— Brand · Stories · Lookbook", "— Marque · Histoires · Lookbook"],
    ["The", "Les"],
    ["Archive.", "Archives."],
    ["Brussels — Est. 2024", "Bruxelles — Depuis 2024"],
    ["Garments built to outlast the cycle.", "Des vêtements conçus pour durer au-delà des saisons."],
    ["For everyone, beyond color.", "Pour tous, au-delà de la couleur."],
    ["Shop the collection", "Voir la collection"],
    ["Not yet, but soon.", "Pas encore, mais bientôt."],
    ["Pieces in development", "Pièces en développement"],
    ["Stay", "Restez"],
    ["connected.", "connectés."],
    ["Join the NSK community.", "Rejoignez la communauté NSK."],
    ["Drop alerts, behind-the-scenes from the studio, and a monthly editorial. No noise — just the work.",
     "Alertes drops, coulisses du studio et un éditorial mensuel. Aucun bruit — juste le travail."],
    ["Subscribe →", "S'inscrire →"],
    ["By subscribing you agree to receive marketing emails from NSK®", "En vous inscrivant, vous acceptez de recevoir les e-mails marketing de NSK®"]
  ];

  const EN2FR = new Map(PAIRS.map(p => [p[0], p[1]]));
  const ATTRS = ["placeholder", "aria-label", "data-success", "alt", "title"];
  const SKIP_SEL = ".cart-body, .cart-foot, .ship-bar, .search-results, .toast";

  let lang = localStorage.getItem("nsk-lang") || "en";
  window.nskLang = () => lang;

  window.t = function (s) {
    if (lang !== "fr") return s;
    return EN2FR.has(s) ? EN2FR.get(s) : s;
  };

  function frFor(key) {
    return EN2FR.has(key) ? EN2FR.get(key) : null;
  }

  function inSkip(node) {
    const el = node.nodeType === 3 ? node.parentElement : node;
    return el && el.closest && el.closest(SKIP_SEL);
  }

  function translateTextNode(n) {
    if (n.__enBase === undefined) n.__enBase = n.nodeValue;
    const raw = n.__enBase;
    const key = raw.trim();
    if (!key) return;
    if (lang === "fr") {
      const fr = frFor(key);
      if (fr !== null) n.nodeValue = raw.replace(key, fr);
    } else {
      n.nodeValue = raw;
    }
  }

  function translateAttrs(el) {
    for (const a of ATTRS) {
      if (!el.hasAttribute(a)) continue;
      const store = "__enAttr_" + a;
      if (el[store] === undefined) el[store] = el.getAttribute(a);
      const raw = el[store];
      const key = raw.trim();
      if (!key) continue;
      if (lang === "fr") {
        const fr = frFor(key);
        if (fr !== null) el.setAttribute(a, raw.replace(key, fr));
      } else {
        el.setAttribute(a, raw);
      }
    }
  }

  function apply() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(n) {
        if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        const p = n.parentNode;
        if (p && (p.tagName === "SCRIPT" || p.tagName === "STYLE")) return NodeFilter.FILTER_REJECT;
        if (inSkip(n)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    let n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(translateTextNode);

    document.querySelectorAll("[" + ATTRS.join("],[") + "]").forEach(el => {
      if (inSkip(el)) return;
      translateAttrs(el);
    });

    document.documentElement.lang = lang;
  }
  window.i18nRefresh = apply;

  window.setLang = function (l) {
    if (l !== "en" && l !== "fr") return;
    lang = l;
    localStorage.setItem("nsk-lang", l);
    apply();
    window.dispatchEvent(new CustomEvent("nsk-langchange", { detail: { lang } }));
  };

  function init() {
    apply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

